import { StackProps, TextProps } from '@chakra-ui/react';
import { MStack, MText } from '../Monetize';

interface StripePaymentMethodTermsProps {
  type: string;
  /**
   * Legal Entity Name
   */
  companyName: string;
  containerProps?: StackProps;
  textProps?: TextProps;
}

/**
 * This is used on end-customer facing anonymous pages, so be mindful of the language and dependencies.
 */
export const StripePaymentMethodTerms = ({
  type,
  companyName,
  containerProps,
  textProps,
}: StripePaymentMethodTermsProps) => {
  if (!type) {
    return null;
  }

  if (type === 'card') {
    return (
      <MStack gap={1} {...containerProps}>
        <MText color="tGray.darkGrayPurple" {...textProps}>
          By providing your card information, you allow {companyName} to charge
          your card for future payments in accordance with their terms.
        </MText>
      </MStack>
    );
  }

  if (type.endsWith('bank_account')) {
    return (
      <MStack gap={1} {...containerProps}>
        <MText color="tGray.darkGrayPurple" {...textProps}>
          By clicking Pay, you authorize {companyName} to debit your bank
          account for charges related to its services or products, as per its
          terms. You may cancel this authorization with 30 days notice.
        </MText>
        <MText color="tGray.darkGrayPurple" {...textProps}>
          For recurring services or purchases, you authorize periodic debits.
          Any additional charges will require your prior authorization.
        </MText>
      </MStack>
    );
  }
  return null;
};
